$(document).ready(function(){
    if($('body').hasClass('contact')){
        $('.location-slider').slick({
            arrows: false,
            dots: true,
            lazyLoad: 'ondemand'
        })
    }
})